import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ModalBody, ModalHeader } from "react-bootstrap";
import AddComponent from "./addComponent";
import ShowComponent from "./showComponent";
import API_BASE_URL, { Providers } from "../../services/Config";
import axios from "axios";
import { useGlobalContext } from "../../services/GlobalContext";
import { v1 as uuidv1 } from "uuid";

import { useDispatch, useSelector } from "react-redux";
import { selectUserList } from "../../store/user/userSelector";
import { fetchUser } from "../../store/user/userSlice";

const MemberModal = ({ showMember, setShowMember }) => {
    const dispatch = useDispatch();
    const [isComplete, setIsComplete] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [update, setUpdate] = useState(false);
    const [editStatus, setEditStatus] = useState(false);
    const [members, setMembers] = useState([]);
    const handleClose = () => setShowMember(false);
    const { setloading } = useGlobalContext();

    const token = localStorage.getItem("authToken");
    const userData = JSON.parse(localStorage.getItem("userData"));
    const provider_id = userData["provider_id"];
    const userList = useSelector(selectUserList);

    useEffect(() => {
        dispatch(fetchUser());
    }, [dispatch]);

    useEffect(() => {
        if (userList.memberList && userList.memberList.elements) {
            const sortedData = userList.memberList.elements
                .map((item) => ({
                    ...item,
                    status: 1,
                }))
                .sort((a, b) => {
                    if (a.status !== b.status) {
                        return a.status - b.status; // Primary sort by status
                    }
                    // Secondary sort by item.state only if status is 1 or 2
                    if (
                        (a.status === 1 || a.status === 2) &&
                        (b.status === 1 || b.status === 2)
                    ) {
                        const statePriority = (state) =>
                            state === "canceled" ? -1 : 0;
                        return statePriority(a.state) - statePriority(b.state); // Prioritize "canceled"
                    }

                    return 0; // No secondary sorting needed for other statuses
                });
            setMembers(sortedData);
        }
    }, [userList.memberList]);

    const newMember = () => {
        const newId = uuidv1();
        setMembers([
            {
                id: newId,
                email: "",
                entity: [],
                access: [],
                status: 0,
            },
            ...members,
        ]);
    };

    const fetchList = async () => {
        setloading(true);
        await axios
            .get(
                `${API_BASE_URL()}/v3/${Providers()}/provider-operators?order_by=-created`,
                {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                const sortedData = res.data.elements
                    .map((item) => ({
                        ...item,
                        status: 1, // Assuming default status as 1 for example purposes
                    }))
                    .sort((a, b) => {
                        if (a.status !== b.status) {
                            return a.status - b.status; // Primary sort by status
                        }
                        // Secondary sort by item.state only if status is 1 or 2
                        if (
                            (a.status === 1 || a.status === 2) &&
                            (b.status === 1 || b.status === 2)
                        ) {
                            const statePriority = (state) =>
                                state === "canceled" ? -1 : 0;
                            return (
                                statePriority(a.state) - statePriority(b.state)
                            ); // Prioritize "canceled"
                        }

                        return 0; // No secondary sorting needed for other statuses
                    });
                setMembers(sortedData);
                setloading(false);
            })
            .catch((e) => {
                console.log(e);
                setloading(false);
            });
    };

    // useEffect(() => {
    //     if (userData?.roles[0] !== "PROVIDEROPERATOR") {
    //         newMember();
    //         fetchList()
    //     }
    // }, [])

    useEffect(() => {
        if (userData?.roles[0] !== "PROVIDEROPERATOR") {
            // dispatch(fetchUser());
        }
    }, [submit, update]);

    return (
        <Modal
            show={showMember}
            onHide={handleClose}
            size="lg"
            aria-labelledby="example-custom-modal-styling-title"
            centered
            style={{
                borderRadius: "1.2rem !important",
                overflow: "hidden",
                minWidth: "90vw !important",
            }}
        >
            <ModalHeader closeButton className="h-[64px] bg-[#F2F5F8]">
                <h3 className="font-24-600 font-color ml-auto ">
                    Membros da Equipa
                </h3>
            </ModalHeader>
            <ModalBody className="h-[70vh] relative">
                <div className="flex flex-col p-[20px] gap-[20px] overflow-scroll h-full mb-12 relative pb-[40px]">
                    <h2 className="text-[#697DA4] font-16-600 self-center">
                        Comece por convidar novos membros para se juntarem à sua
                        equipa!
                    </h2>
                    {members?.length > 0 ? (
                        members?.map((item, index) => {
                            return item.status === 4 || item.status === 0 ? (
                                <AddComponent
                                    setIsComplete={setIsComplete}
                                    setMembers={setMembers}
                                    members={members}
                                    item={item}
                                    submit={submit}
                                    setSubmit={setSubmit}
                                    setUpdate={setUpdate}
                                    update={update}
                                    setEditStatus={setEditStatus}
                                    editStatus={editStatus}
                                    key={index}
                                />
                            ) : (
                                <ShowComponent
                                    item={item}
                                    setMembers={setMembers}
                                    members={members}
                                    setEditStatus={setEditStatus}
                                    key={index}
                                />
                            );
                        })
                    ) : (
                        <AddComponent
                            setIsComplete={setIsComplete}
                            setMembers={setMembers}
                            members={members}
                            item={[]}
                            submit={submit}
                            setSubmit={setSubmit}
                            setUpdate={setUpdate}
                            update={update}
                            setEditStatus={setEditStatus}
                            editStatus={editStatus}
                        />
                    )}

                    <button
                        className="text-[#F9BC04] font-14-700 text-left absolute top-[20px] right-[30px]"
                        onClick={() => newMember()}
                    >
                        + Adicionar mais membros
                    </button>
                </div>
                {members?.length === 0 ? (
                    isComplete ? (
                        <button
                            className="absolute bottom-0 h-[50px] bg-[#F9BC04] w-full"
                            onClick={() => setSubmit(true)}
                        >
                            <span className="font-15-900 text-white">
                                CONVIDAR
                            </span>
                        </button>
                    ) : (
                        <button className="absolute bottom-0 h-[50px] bg-[#F2F5F8] w-full">
                            <span className="font-15-900 text-[#B2C3D4]">
                                CONVIDAR
                            </span>
                        </button>
                    )
                ) : members?.some((member) => member.status === 0) ? (
                    isComplete ? (
                        <button
                            className="absolute bottom-0 h-[50px] bg-[#F9BC04] w-full"
                            onClick={() => setSubmit(true)}
                        >
                            <span className="font-15-900 text-white">
                                CONVIDAR
                            </span>
                        </button>
                    ) : (
                        <button className="absolute bottom-0 h-[50px] bg-[#F2F5F8] w-full">
                            <span className="font-15-900 text-[#B2C3D4]">
                                CONVIDAR
                            </span>
                        </button>
                    )
                ) : (
                    <></>
                )}
            </ModalBody>
        </Modal>
    );
};

export default MemberModal;
